/*
 * © BLUCKYADAY
 * All rights reserved.
 */

/* ระบบแปลภาษา (en / th / zh) ตามภาษาที่เลือกใน Shopify
   คำแปลอยู่ใน study_text ด้านบนของไฟล์ .liquid
   ต้องรันก่อนส่วนอื่น เพราะส่วนอื่นอ่านข้อความจาก data-* ตอนเริ่ม */
var studyT = (function () {
  var app = document.querySelector(".study-app");
  var dict = {},
    lang = "en";
  if (!app)
    return function (key, fallback) {
      return fallback;
    };
  try {
    dict = JSON.parse(app.querySelector("[data-study-text]").textContent);
  } catch (e) {}
  var src = (
    app.dataset.locale ||
    document.documentElement.lang ||
    "en"
  ).toLowerCase();
  if (src.indexOf("th") === 0) lang = "th";
  else if (src.indexOf("zh") === 0) lang = "zh";

  function t(key, fallback) {
    var entry = dict[key];
    return (entry && (entry[lang] || entry.en)) || fallback;
  }
  /* data-i18n="key" = เปลี่ยนข้อความในแท็ก */
  app.querySelectorAll("[data-i18n]").forEach(function (el) {
    el.textContent = t(el.dataset.i18n, el.textContent);
  });
  /* data-i18n-attr="ชื่อ attribute:key; ..." = เปลี่ยนค่า attribute */
  app.querySelectorAll("[data-i18n-attr]").forEach(function (el) {
    el.dataset.i18nAttr.split(";").forEach(function (pair) {
      var parts = pair.split(":"),
        attr = parts[0].trim(),
        key = (parts[1] || "").trim();
      if (attr && key) el.setAttribute(attr, t(key, el.getAttribute(attr)));
    });
  });
  return t;
})();

/* ระบบเครื่องเล่นเพลง */
(function () {
  function fmt(s) {
    s = Math.floor(s || 0);
    return Math.floor(s / 60) + ":" + ("0" + (s % 60)).slice(-2);
  }
  document.querySelectorAll(".vinyl-player").forEach(function (p) {
    var audio = p.querySelector(".vp-audio"),
      play = p.querySelector(".vp-play"),
      bar = p.querySelector(".vp-progress"),
      fill = p.querySelector(".vp-progress-fill"),
      time = p.querySelector(".vp-time"),
      title = p.dataset.title || "",
      artist = p.dataset.artist || "";

    audio.src = p.dataset.src;
    audio.loop = p.dataset.loop === "true";
    var cover = p.querySelector(".vp-cover");
    cover.addEventListener("error", function () {
      cover.classList.add("is-missing");
    });
    cover.src = p.dataset.cover;
    p.querySelector(".vp-label-artist").textContent = artist;
    p.querySelector(".vp-arc-title").textContent = (
      title.length > 12 ? title.slice(0, 10).trim() + "..." : title
    ).toUpperCase();
    p.querySelectorAll(".vp-question").forEach(function (q) {
      q.textContent = p.dataset.question || "";
    });
    p.querySelector(".vp-affirmation").textContent =
      p.dataset.affirmation || "";

    function upd() {
      time.textContent = fmt(audio.currentTime) + " / " + fmt(audio.duration);
      if (audio.duration)
        fill.style.width = (audio.currentTime / audio.duration) * 100 + "%";
    }
    play.addEventListener("click", function () {
      if (audio.paused) {
        audio.play().catch(function () {
          time.textContent = "ยังไม่ได้ใส่ URL เพลง";
        });
      } else audio.pause();
    });
    audio.addEventListener("play", function () {
      p.classList.add("is-playing");
      play.setAttribute("aria-label", studyT("pause", "Pause"));
    });
    audio.addEventListener("pause", function () {
      p.classList.remove("is-playing");
      play.setAttribute("aria-label", studyT("play", "Play"));
    });
    audio.addEventListener("ended", function () {
      p.classList.remove("is-playing");
      var rec = p.querySelector(".vp-record");
      rec.style.animation = "none";
      void rec.offsetWidth;
      rec.style.animation = "";
    });
    audio.addEventListener("loadedmetadata", upd);
    audio.addEventListener("timeupdate", upd);
    bar.addEventListener("click", function (e) {
      var r = bar.getBoundingClientRect();
      if (audio.duration)
        audio.currentTime = ((e.clientX - r.left) / r.width) * audio.duration;
    });
  });
})();

/* ระบบแท็บและตัวจับเวลา */
(function () {
  var app = document.querySelector(".study-app");
  if (!app) return;
  /* คำแปล (ถ้าไม่มีจะใช้ภาษาอังกฤษ) */
  var TXT_START = studyT("start", "Start");
  var TXT_PAUSE = studyT("pause", "Pause");
  var TXT_MUSIC_BY = studyT("music_by", "Music by");
  /* หยุดเพลงและเวลาภายใน panel ที่กำลังจะถูกซ่อน */
  function pausePanel(panel) {
    if (!panel) return;

    /* หยุดไฟล์เสียงและวิดีโอปกติ */
    panel.querySelectorAll("audio, video").forEach(function (media) {
      media.pause();
    });

    /* หยุด YouTube iframe */
    panel.querySelectorAll("iframe").forEach(function (iframe) {
      if (/youtube\.com\/embed/.test(iframe.src)) {
        iframe.contentWindow.postMessage(
          JSON.stringify({
            event: "command",
            func: "pauseVideo",
            args: [],
          }),
          "*",
        );
      }
    });

    /* หยุดตัวจับเวลา */
    panel.querySelectorAll(".timer-card").forEach(function (card) {
      if (typeof card.pauseTimer === "function") {
        card.pauseTimer();
      }
    });
  }

  /* ---- tabs ---- */
  var tabBtns = app.querySelectorAll(".tab-btn");
  var panels = app.querySelectorAll(".panel[data-panel]");

  tabBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.dataset.tab;

      tabBtns.forEach(function (b) {
        b.classList.toggle("is-active", b === btn);
      });

      panels.forEach(function (panel) {
        var willHide = panel.dataset.panel !== key;

        /* ก่อนซ่อนแท็บ ให้หยุดเพลงและเวลาก่อน */
        if (willHide && !panel.hidden) {
          pausePanel(panel);
        }

        panel.hidden = willHide;
      });
    });
  });

  /* ---- gentle chime when a timer finishes ---- */
  function ding() {
    try {
      var ac = new (window.AudioContext || window.webkitAudioContext)();
      [0, 0.22, 0.44].forEach(function (t) {
        var o = ac.createOscillator(),
          g = ac.createGain();
        o.type = "sine";
        o.frequency.value = 784;
        g.gain.setValueAtTime(0.0001, ac.currentTime + t);
        g.gain.exponentialRampToValueAtTime(0.22, ac.currentTime + t + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + t + 0.3);
        o.connect(g).connect(ac.destination);
        o.start(ac.currentTime + t);
        o.stop(ac.currentTime + t + 0.32);
      });
    } catch (e) {}
  }

  /* ---- turn a pasted YouTube / SoundCloud / Spotify link into a working embed ---- */
  function buildAudioEmbed(raw) {
    if (!raw) return null;
    var s = raw.trim();

    // YouTube: watch, youtu.be, live, or already-embed URLs
    var yt = s.match(
      /(?:youtube\.com\/(?:watch\?v=|live\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/,
    );
    if (yt)
      return {
        src: "https://www.youtube.com/embed/" + yt[1] + "?rel=0&enablejsapi=1",
        height: 190,
      };
    var ytList = s.match(/youtube\.com\/playlist\?list=([A-Za-z0-9_-]+)/);
    if (ytList)
      return {
        src:
          "https://www.youtube.com/embed/videoseries?list=" +
          ytList[1] +
          "&rel=0",
        height: 190,
      };

    // SoundCloud: wrap any track/set URL in their widget player
    if (/soundcloud\.com\//.test(s)) {
      return {
        src:
          "https://w.soundcloud.com/player/?url=" +
          encodeURIComponent(s) +
          "&color=%233a4148&auto_play=false&show_teaser=false",
        height: 140,
      };
    }

    // Spotify: works, but only logged-in Spotify visitors hear the full track (others get a 30s preview)
    var sp = s.match(
      /open\.spotify\.com\/(?:intl-[a-z]{2}\/)?(track|album|playlist|artist|show|episode)\/([A-Za-z0-9]+)/,
    );
    if (!sp)
      sp = s.match(
        /spotify:(track|album|playlist|artist|show|episode):([A-Za-z0-9]+)/,
      );
    if (sp) {
      var type = sp[1],
        id = sp[2];
      var height = type === "track" || type === "episode" ? 152 : 352;
      return {
        src:
          "https://open.spotify.com/embed/" +
          type +
          "/" +
          id +
          "?utm_source=generator",
        height: height,
      };
    }
    return null;
  }
  app.querySelectorAll(".timer-audio").forEach(function (slot) {
    var link = slot.dataset.audio || "";
    var emb = buildAudioEmbed(link);
    if (emb) {
      slot.style.height = emb.height + "px";
      var ifr = document.createElement("iframe");
      ifr.src = emb.src;
      ifr.allow =
        "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture";
      ifr.loading = "lazy";
      slot.appendChild(ifr);
    } else {
      slot.classList.add("is-empty");
      slot.innerHTML =
        '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg><span>ยังไม่ได้ใส่ลิงก์เพลง<br>แก้ได้ที่ data-audio ในโค้ด<br>(รองรับ YouTube / SoundCloud / Spotify)</span>';
    }
  });

  /* ---- optional small credit line under each player (blank = shows nothing) ---- */
  app.querySelectorAll(".timer-credit").forEach(function (el) {
    var name = el.dataset.creditName || "";
    var url = el.dataset.creditUrl || "";
    if (!name) return;
    el.innerHTML =
      "🎵 " +
      TXT_MUSIC_BY +
      " " +
      (url
        ? '<a href="' +
          url +
          '" target="_blank" rel="noopener">' +
          name +
          "</a>"
        : name);
  });

  /* ---- pomodoro / break timers ---- */
  app.querySelectorAll(".timer-card").forEach(function (card) {
    var label = card.dataset.label || "";
    var display = card.querySelector(".timer-display");
    var startBtn = card.querySelector(".timer-start");
    var resetBtn = card.querySelector(".timer-reset");
    var noteBox = card.querySelector(".timer-note");
    var noteTitle = card.querySelector(".timer-note-title");
    var noteMsg = card.querySelector(".timer-note-message");
    var arcTitle = card.querySelector(".vp-arc-title");

    if (arcTitle) arcTitle.textContent = label;
    if (noteTitle) noteTitle.textContent = noteBox.dataset.noteTitle || "";
    if (noteMsg) noteMsg.textContent = noteBox.dataset.noteMessage || "";

    var defaultMin = parseInt(card.dataset.defaultMin, 10) || 25;
    var remaining = defaultMin * 60;
    var timer = null;
    var finishAt = 0;

    function fmt(sec) {
      sec = Math.max(0, Math.ceil(sec));
      var m = Math.floor(sec / 60),
        s = sec % 60;
      return (m < 10 ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s;
    }
    function render() {
      display.textContent = fmt(remaining);
    }
    render();

    function updateRemaining() {
      if (!finishAt) return;
      remaining = Math.max(0, Math.ceil((finishAt - Date.now()) / 1000));
    }

    function stop() {
      if (timer) updateRemaining();
      clearInterval(timer);
      timer = null;
      finishAt = 0;
      card.classList.remove("is-running");
      startBtn.textContent = TXT_START;
      render();
    }
    card.pauseTimer = stop;

    function reset() {
      clearInterval(timer);
      timer = null;
      finishAt = 0;
      remaining = defaultMin * 60;
      card.classList.remove("is-running");
      startBtn.textContent = TXT_START;
      render();
    }

    function tick() {
      updateRemaining();
      render();

      if (remaining <= 0) {
        remaining = 0;
        clearInterval(timer);
        timer = null;
        finishAt = 0;
        card.classList.remove("is-running");
        startBtn.textContent = TXT_START;
        render();
        ding();
      }
    }

    function start() {
      if (remaining <= 0) remaining = defaultMin * 60;
      finishAt = Date.now() + remaining * 1000;
      card.classList.add("is-running");
      startBtn.textContent = TXT_PAUSE;
      clearInterval(timer);
      timer = setInterval(tick, 250);
      tick();
    }

    startBtn.addEventListener("click", function () {
      if (timer) {
        stop();
      } else {
        start();
      }
    });
    resetBtn.addEventListener("click", reset);

    /* click the big digits (while stopped) to set a custom number of minutes */
    display.addEventListener("click", function () {
      if (timer) return; // don't edit while running
      var input = document.createElement("input");
      input.type = "number";
      input.min = "1";
      input.max = "180";
      input.value = defaultMin;
      display.textContent = "";
      display.appendChild(input);
      input.focus();
      input.select();

      function commit() {
        var v = parseInt(input.value, 10);
        if (!v || v < 1) v = 1;
        if (v > 180) v = 180;
        defaultMin = v;
        remaining = defaultMin * 60;
        render();
      }
      input.addEventListener("blur", commit);
      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          input.blur();
        }
      });
    });
  });
})();
